/*
 * @Descripttion:
 * @FilePath: /mall-wap-vue/src/utils/mixin.js
 * @Author: 张兴业
 * @Date: 2020-11-10 09:33:59
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-11-10 09:36:33
 */
import Vue from "vue";

Vue.mixin({
  computed: {
    slug() {
      return this.$route.query.slug || "";
    }
  }
});
